import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
const About = resolve => require(['@/components/About'], resolve);
const Goods = resolve => require(['@/components/Goods'], resolve);
const Contact = resolve => require(['@/components/Contact'], resolve);

Vue.use(Router);
// 解决报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/About', // 关于
      name: 'About',
      component: About
    },
    {
      path: '/Goods', // 商城
      name: 'Goods',
      component: Goods
    },
    {
      path: '/Contact', // 联系我们
      name: 'Contact',
      component: Contact
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js